module.exports = __webpack_public_path__ + "img/ingenieria.b840ee0e.jpg";